import type { ReactNode } from 'react';

export const symbol_nordic_walking: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m174-64 70-311q2-7 7.5-11t12.5-4q10 0 15.5 7t3.5 17L213-55q-2 7-7.5 11T193-40q-10 0-15.5-7T174-64Zm111-12 110-553-102 46v103q0 13-8.5 21.5T263-450q-13 0-21.5-8.5T233-480v-123q0-9 5-16.5t13-11.5l173-73q26-11 59.5-6t50.5 31l42 66q23 37 61.5 65t86.5 36q12 2 20.5 11t8.5 21q0 13-8.5 21.5T724-452q-57-6-103.5-36T536-572l-41 156 82 74q5 5 7.5 10.5T587-320v250q0 13-8.5 21.5T557-40q-13 0-21.5-8.5T527-70v-210l-108-98-74 315q-2 11-10.5 17T315-40q-14 0-23.5-11T285-76Zm255-671q-30 0-51.5-21.5T467-820q0-30 21.5-51.5T540-893q30 0 51.5 21.5T613-820q0 30-21.5 51.5T540-747ZM713-60v-310q0-8 6-14t14-6q8 0 14 6t6 14v310q0 8-6 14t-14 6q-8 0-14-6t-6-14Z"
		/>
	</svg>
);
